import React from 'react'
import addButtonImage from '../../images/addButton.svg'


export default function AddButton(props: { [key: string]: unknown }) {
  return (
    <img src={addButtonImage} alt="addButtonImage" width="18" height="18" />
  )
}